import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import {
  markAllOrderNotificationsReadOptions,
  orderNotificationsOptions,
} from '@lib/api/options/orders';
import { MutationCallbackOptions } from '@lib/api/options/types';
import { getRateLimitMessage } from '@lib/utils/error-handler';

export const useMarkAllOrderNotificationsRead = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutateAsync: onReadAll, isPending: readingAll } = useMutation(
    markAllOrderNotificationsReadOptions(),
  );

  const handleOnReadAll = (callbacks?: MutationCallbackOptions<void>) =>
    onReadAll(undefined, {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: orderNotificationsOptions().queryKey,
        });
        message.success('Todas as notificações foram marcadas como lidas.');
        callbacks?.onCompleted?.();
      },
      onError: (error) => {
        message.error(
          getRateLimitMessage(error) ??
            'Não foi possível marcar todas as notificações como lidas. Tente novamente.',
        );
        callbacks?.onError?.(error);
      },
    });

  return { markAllRead: handleOnReadAll, readingAll };
};
